/**
 * appendTrackingParams(url)
 *
 * Forwards UTM and click-tracking params from the current page URL to a
 * downstream destination (e.g. the subscription / checkout URL). This way
 * marketing attribution survives the hop from landing → checkout.
 *
 * Preserves any params already on the destination URL — won't overwrite.
 */
const TRACKING_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_id',
  'gclid',     // Google Ads
  'fbclid',    // Meta Ads
  'msclkid',   // Microsoft Ads
  'ttclid',    // TikTok Ads
  'li_fat_id', // LinkedIn
  'ref',
];

export function appendTrackingParams(url) {
  if (!url || typeof window === 'undefined') return url;
  try {
    const current = new URLSearchParams(window.location.search);
    if (current.toString() === '') return url;
    const dest = new URL(url);
    TRACKING_KEYS.forEach((k) => {
      const v = current.get(k);
      if (v && !dest.searchParams.has(k)) {
        dest.searchParams.set(k, v);
      }
    });
    return dest.toString();
  } catch {
    return url;
  }
}
